// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ef-0";